export const appHead = {"link":[{"rel":"mask-icon","sizes":"57x57","href":"/favicon/safari-pinned-tab.svg"},{"rel":"shortcut icon","media":"(prefers-color-scheme: light)","href":"/favicon/favicon.ico"},{"rel":"apple-touch-icon","sizes":"57x57","href":"/favicon/apple-icon-57x57.png"},{"rel":"apple-touch-icon","sizes":"60x60","href":"/favicon/apple-icon-60x60.png"},{"rel":"apple-touch-icon","sizes":"72x72","href":"/favicon/apple-icon-72x72.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"/favicon/apple-icon-76x76.png"},{"rel":"apple-touch-icon","sizes":"114x114","href":"/favicon/apple-icon-114x114.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"/favicon/apple-icon-120x120.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"/favicon/apple-icon-144x144.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"/favicon/apple-icon-152x152.png"},{"rel":"icon","type":"image/png","sizes":"192x192","href":"/favicon/android-icon-192x192.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"96x96","href":"/favicon/favicon-96x96.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon/favicon-16x16.png"},{"rel":"icon","type":"image/svg+xml","href":"/favicon/favicon.svg"},{"rel":"alternate icon","type":"image/png","sizes":"32x32","href":"/favicon/favicon-32x32.png"},{"rel":"alternate icon","type":"image/png","media":"(prefers-color-scheme: dark)","href":"/favicon/favicon-dark.png"},{"rel":"icon","type":"image/svg+xml","media":"(prefers-color-scheme: dark)","href":"/favicon/favicon-dark.svg"},{"rel":"shortcut icon","type":"image/x-icon","media":"(prefers-color-scheme: dark)","href":"/favicon/favicon-dark.ico"},{"rel":"preconnect","href":"https://fonts.gstatic.com","crossorigin":"anonymous"},{"rel":"preconnect","href":"https://www.gstatic.com","crossorigin":"anonymous"},{"rel":"preconnect","href":"https://www.google.com","crossorigin":"anonymous"}],"meta":[{"charset":"utf-8"},{"name":"description","content":"Scale conversations with Kudosity's 20+ years of messaging innovation. Explore global connectivity, SaaS platforms, and AI-driven conversational automation."},{"name":"application-name","content":"Kudosity"},{"name":"color-scheme","content":"light only"},{"name":"viewport","content":"width=device-width, initial-scale=1.0"},{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"msapplication-TileImage","content":"/favicon/ms-icon-144x144.png"},{"name":"msapplication-config","content":"/favicon/browserconfig.xml"},{"name":"theme-color","content":"#4c23cc"},{"property":"og:type","content":"website"}],"style":[],"script":[],"noscript":[],"htmlAttrs":{"lang":"en-AU"},"title":"Grow customer relationships with messaging experiences | Kudosity"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true